// extracted by mini-css-extract-plugin
export default {"see-more":"TruncatedText_see-more__vgh2I"};